import {AppUrls} from 'shared/config/model/urls';

import React from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import Exit from 'shared/ui/icons/NavMenu/Exit';
import {IUserOutput} from 'entities/user';
import {isImpersonator, logout} from 'shared/api/auth';
import {TypedDispatch} from 'shared/model/types';

import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import styles from './UserInformer.module.scss';

interface IUserInformerProps {
    user: IUserOutput | null,
     
}

const UserInformer: React.FC<IUserInformerProps> = ({user}) => {
    const dispatch = useDispatch<TypedDispatch>();
    const navigate = useNavigate();


    const handleLogout = async(event: React.MouseEvent) => {
        event.preventDefault();
        const impersonator = isImpersonator();
        const savedUrl = localStorage.getItem('return_url_after_impersonation');
        await logout(dispatch);
        const returnPath = impersonator && savedUrl
            ? savedUrl
            : AppUrls.LOGIN;
        navigate(returnPath);
    };

    return (
        <div className={styles.wrapper}>

            <div className={styles.text}>
                {user?.first_name} {user?.last_name}
            </div>

            <div
                className={cn(
                    styles.icon,
                    isTranslate() && styles.iconEn,
                )}
                onClick={handleLogout}
            >
                <Exit/>
            </div>

        </div>
    );
};

export default UserInformer;